import { render, staticRenderFns } from "./OrderTypeSelectionPopUp.vue?vue&type=template&id=6187ab24&"
import script from "./OrderTypeSelectionPopUp.vue?vue&type=script&lang=js&"
export * from "./OrderTypeSelectionPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports